import React, { useLayoutEffect, useRef, useState } from "react";
import { Wrapper } from "./index.styled";
import FullScreenCopy from "components/fullscreen-copy";
import Pagination from "components/pagination";
import FullScreenImage from "components/fullscreen-image";
import Slider from "components/content-slider";
import Plan from "./plan";
import { gsap, ScrollTrigger } from "helpers/gsap";
import AnchorList from "components/anchor-list";
import InfoSection from "./info";

const Club = ({ data }) => {
  const refWrapper = useRef(null);
  const [activeAnchor, setActiveAnchor] = useState(null);
  const [anchorColor, setAnchorColor] = useState(false);

  useLayoutEffect(() => {
    let gsapContext = gsap.context(() => {
      const mediaQueryAnimation = gsap.matchMedia();
      const slidersSection = Array.from(
        document.querySelectorAll(".content-slider")
      );
      slidersSection.forEach((slider) => {
        const tl = gsap.timeline().from(
          slider,
          {
            yPercent: 5,
            opacity: 0,
            duration: 1,
          },
          0
        );

        ScrollTrigger.create({
          trigger: slider,
          start: "top center+=20%",
          animation: tl,
          toggleActions: "play none none reverse",
        });
      });

      mediaQueryAnimation.add("(min-width: 1025px)", () => {
        ScrollTrigger.create({
          trigger: ".ancor-list-club",
          pin: true,
          pinSpacing: false,
          endTrigger: "#club-owner-program",
          end: "bottom bottom",
          start: "center center",
        });

        const createScrollTrigger = (
          triggerClass,
          setActiveAnchorCallback,
          anchorName
        ) => {
          const elements = gsap.utils.toArray(triggerClass);
          elements.forEach((element) => {
            ScrollTrigger.create({
              trigger: element,
              start: "top center",
              end: "bottom center",
              onEnter: () => {
                setActiveAnchorCallback(anchorName);
              },
              onEnterBack: () => {
                setActiveAnchorCallback(anchorName);
              },
              onLeaveBack: () => {
                setActiveAnchorCallback("");
              },
              onLeave: () => {
                setActiveAnchorCallback("");
              },
              onComplete: () => {
                ScrollTrigger.refresh();
              },
            });
          });
        };
        createScrollTrigger(".arrival-section", setActiveAnchor, "arrival");
        createScrollTrigger(".park-section", setActiveAnchor, "the park");
        createScrollTrigger(
          ".lower-level-section",
          setActiveAnchor,
          "lower level"
        );
        createScrollTrigger(
          ".club-36th-floor-section",
          setActiveAnchor,
          "36th floor"
        );

        const darkLogoSections = gsap.utils.toArray(".dark-anchor-section");
        darkLogoSections.forEach((section, index) => {
          ScrollTrigger.create({
            trigger: section,

            start: `top center`,
            end: `bottom center`,
            onEnter: () => setAnchorColor(true),
            onLeave: () => setAnchorColor(false),
            onEnterBack: () => setAnchorColor(true),
            onLeaveBack: () => setAnchorColor(false),
          });
        });
      });
    }, refWrapper);

    return () => gsapContext.revert();
  }, []);

  return (
    <Wrapper ref={refWrapper}>
      {data?.map((section, index) => {
        if (section.type === "fullscreenImage") {
          return (
            <FullScreenImage data={section} key={`club-section-${index}`} />
          );
        } else if (section.type === "anchorList") {
          return (
            <AnchorList
              color={anchorColor === true ? "dark" : "white"}
              data={section}
              key={`club-section-${index}`}
              className="ancor-list-club"
              active={activeAnchor}
            />
          );
        } else if (section.type === "fullscreenCopy") {
          return (
            <FullScreenCopy data={section} key={`club-section-${index}`} />
          );
        } else if (section.type === "infoSlider") {
          return <Slider data={section} key={`club-section-${index}`} />;
        } else if (section.type === "plan") {
          return <Plan data={section} key={`club-section-${index}`} />;
        } else if (section.type === "ownerProgram") {
          return <InfoSection data={section} key={`club-section-${index}`} />;
        } else if (section.type === "pagination") {
          return <Pagination data={section} key={`club-section-${index}`} />;
        }
      })}
    </Wrapper>
  );
};

export default Club;
